import { isQuoteFlow } from '@stopal/shared/order-form'
import { ORDER_STATUSES } from '@stopal/shared/order-status'
import { format, isValid, parseISO } from 'date-fns'

const STATUSES = new Set<string>(ORDER_STATUSES)
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const isIsoDate = (value: unknown): value is string => {
  if (typeof value !== 'string' || !ISO_DATE.test(value)) return false
  const parsed = parseISO(value)
  return isValid(parsed) && format(parsed, 'yyyy-MM-dd') === value
}

export interface OrdersSearch {
  q?: string
  statuses?: string
  flows?: string
  sites?: string
  from?: string
  to?: string
  sort?: 'newest' | 'oldest'
}

function listOf<T extends string>(
  value: unknown,
  accepts: (item: string) => item is T,
): string | undefined {
  if (typeof value !== 'string') return undefined
  const values = [...new Set(value.split(',').filter(accepts))]
  return values.length ? values.join(',') : undefined
}

export function validateOrdersSearch(
  raw: Record<string, unknown>,
): OrdersSearch {
  return {
    q:
      typeof raw.q === 'string' && raw.q.trim() && raw.q.length <= 100
        ? raw.q
        : undefined,
    statuses: listOf(raw.statuses, (value): value is string =>
      STATUSES.has(value),
    ),
    flows: listOf(raw.flows, isQuoteFlow),
    sites: listOf(raw.sites, (value): value is string => UUID.test(value)),
    from: isIsoDate(raw.from) ? raw.from : undefined,
    to: isIsoDate(raw.to) ? raw.to : undefined,
    sort: raw.sort === 'oldest' || raw.sort === 'newest' ? raw.sort : undefined,
  }
}
